// frontend/src/components/citations/CitationsPanel.jsx

import { useTranslation } from 'react-i18next';
import i18n from '../../locales/i18n';

import { resolveCAPEVAdaptation } from '../../activities/cape-v/capevAdaptations';
import CAPEVCitation from './CAPEVCitation';
import CAPEVRCitation from './CAPEVRCitation';
import GRBASCitation from './GRBASCitation';

import VoiceDatabaseCitation from './VoiceDatabaseCitation';
import VoiceCollectionCitation from './VoiceCollectionCitation';
import RepresentationTransformationsCitation from './RepresentationTransformationsCitation';

import PROMCitations from './PROMCitations';
import ResearchCitation from './ResearchCitation';


const CitationsPanel = ({
  toolName,
  voiceDatabase,
  voiceCollection,
  promNames = [],
  capevAdaptationId = "en",
  capevrModificationNote = null,
  researchCitations = [],
  representationTransformations = []
}) => {
  const { t } = useTranslation();
  const capevT =
    toolName === 'CAPE-V'
      ? i18n.getFixedT(resolveCAPEVAdaptation(capevAdaptationId).i18nKey)
      : null;
  const headingT = capevT || t;
  const collectionVoiceDatabase =
    typeof voiceCollection?.voiceDatabaseId === 'object'
      ? voiceCollection.voiceDatabaseId
      : voiceCollection?.voiceDatabase || null;
  const resolvedVoiceDatabase =
    collectionVoiceDatabase || voiceDatabase;

  const hasToolCitation =
    toolName === 'CAPE-V' ||
    toolName === 'CAPE-Vr' ||
    toolName === 'GRBAS';

  const hasVoiceCitation =
    Boolean(resolvedVoiceDatabase) || Boolean(voiceCollection);
  const hasPROMCitations = promNames.length > 0;
  const hasResearchCitations = researchCitations.length > 0;
  const hasRepresentationTransformations = representationTransformations.length > 0;


  if (
    !hasToolCitation &&
    !hasVoiceCitation &&
    !hasPROMCitations &&
    !hasResearchCitations &&
    !hasRepresentationTransformations
  ) return null;

  return (
    <div className="references">
      <br/>
      <h3>{headingT('references')}</h3>

      {/* Eina d’avaluació auditivo-perceptiva */}
      {toolName === 'CAPE-V' && (
        <CAPEVCitation adaptationId={capevAdaptationId} />
      )}

      {toolName === 'CAPE-Vr' && (
        <CAPEVRCitation modificationNote={capevrModificationNote} />
      )}

      {toolName === 'GRBAS' && <GRBASCitation />}

      {/* PROMs */}
      {hasPROMCitations && promNames.map((name) => (
        <PROMCitations key={name} promName={name} />
      ))}

      {/* Base de dades */}
      {resolvedVoiceDatabase && (
        <VoiceDatabaseCitation
          database={resolvedVoiceDatabase}
          labelT={capevT}
          showCollectionChangesNote={Boolean(voiceCollection)}
        >
          {!voiceCollection && hasRepresentationTransformations ? (
            <RepresentationTransformationsCitation
              transformations={representationTransformations}
              labelT={capevT}
            />
          ) : null}
        </VoiceDatabaseCitation>
      )}

      {/* Col·lecció de mostres */}
      {voiceCollection && (
        <VoiceCollectionCitation
          collection={voiceCollection}
          labelT={capevT}
        />
      )}

       {/* Altres cites de recerca */}
      {hasResearchCitations && researchCitations.map((type) => (
        <ResearchCitation key={type} type={type} />
      ))}
    </div>
  );
};

export default CitationsPanel;
